export const colorPieChart = [
  '#4E79A7', // blue
  '#F28E2B', // orange
  '#E15759', // red
  '#76B7B2', // teal
  '#59A14F', // green
  '#EDC949', // yellow
  '#AF7AA1', // purple
  '#FF9DA7', // pink
  '#9C755F', // brown
  '#BAB0AC' // gray
];
export const colorCallsStatus = ['#FDB022', '#F97066', '#1E90FF', '#F04438', '#875BF7', '#32D583', '#FF3800'];

export const widgetPieChartColord = [
  '#D83F31',
  '#7743DB',
  '#FFB534',
  '#65B741',
  '#0CAF61',
  '#8B62FF',
  '#FDDC61',
  '#FE9649',
  '#0766AD'
];

export const flatAreaChartColor = ['#FFD572', '#FF9364'];
